module.exports = __webpack_public_path__ + "static/media/aeromexico-icon.6b0fc402.svg";